import React from 'react';
import {NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH,} from 'constants/ThemeConstant';
import {APP_NAME} from 'configs/AppConfig';
import {connect} from 'react-redux';
import utils from 'utils';
import {Grid} from 'antd';

const { useBreakpoint } = Grid;

const getLogoWidthGutter = (props, isMobile) => {
	const { navCollapsed, navType } = props;
	const isNavTop = navType === NAV_TYPE_TOP ? true : false;
	if (isMobile && !props.mobileLogo) {
		return 0;
	}
	if (isNavTop) {
		return 'auto';
	}
	if (navCollapsed) {
		return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
	} else {
		return `${SIDE_NAV_WIDTH}px`;
	}
};

export const getLogo = (props) => {
	const { navCollapsed, currentTheme } = props;
	if (currentTheme === 'dark') {
		if (navCollapsed) {
			return '/img/est-logo-simple-dark.svg';
		}
		return '/img/est-logo-dark.svg';
	}

	if (navCollapsed) {
		return '/img/est-logo-simple-light.svg';
	}
	return '/img/est-logo-light.svg';
};

const getLogoDisplay = (isMobile, mobileLogo) => {
	if (isMobile && !mobileLogo) {
		return 'd-none';
	} else {
		return 'logo';
	}
};

export const Logo = (props) => {
	const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg');
	return (
		<div
			className={`${getLogoDisplay(isMobile, props.mobileLogo)} ${
				props.className
			}`}
			style={{ width: `${getLogoWidthGutter(props, isMobile)}` }}
		>
			<img className={props.navCollapsed ? "center-logo" : null} src={getLogo(props)} alt={`${APP_NAME} Logo`} />
		</div>
	);
};

const mapStateToProps = ({ theme }) => {
	const { navCollapsed, navType, currentTheme } = theme;
	return { navCollapsed, navType, currentTheme };
};

export default connect(mapStateToProps)(Logo);
